export default __webpack_public_path__ + "static/media/del_icon.430de2a8.svg";